import React from 'react';
import ApexChart from "react-apexcharts";
import dayjs from 'dayjs';

const BarChart = (props) => {
  const dates = props.series.map(series => dayjs(series.date).format("ll"));
  const values = props.series.map(series => series.amount);

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
      background: 'transparent',
      sparkline: { enabled: true },
      offsetY: -5
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: dates,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      show: false,
      min: 0,
    },
    grid: { show: false },
    legend: { show: false },
    fill: { opacity: 1 },
    plotOptions: {
      bar: {
        columnWidth: 6
      }
    },
    tooltip: {
      y: {
        formatter: (value) => value === 0.05 ? 0 : value
      }
    },
    colors: ['var(--color-greyDark)', 'var(--color-purple)'],
  };

  const series = [
    {
      name: 'Solutions',
      data: values.map(() => 0.05)
    },
    {
      name: 'Solutions',
      data: values.map(val => val === 0 ? null : val)
    }
  ];

  return (
    <ApexChart
      height={90}
      options={options}
      series={series}
      type="bar"
    />
  );
};

export default BarChart;